import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import UolIcon from '../icons/uol.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class VideoUol extends Plugin {
  static get requires() {
    return [MediaEmbed];
  }

  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('videoUol', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Coloque o ID do vídeo no uol / SHIVA',
        icon: UolIcon,
        tooltip: true,
      });

      // Callback executed once the image is clicked.
      view.on('execute', async () => {
        const { value: id } = await Swal.fire({
          input: 'text',
          inputPlaceholder: 'Coloque o ID do vídeo no uol / SHIVA',
        });

        if (id) {
          editor.model.change((writer) => {
            const video = writer.createElement('media', {
              url: `https://player.mais.uol.com.br/?mediaId=${id}&amp;autoplay=false&amp;share=false&amp;related=false`,
            });

            // Insert the image in the current selection location.
            editor.model.insertContent(video, editor.model.document.selection);
          });
        }
      });

      return view;
    });
  }
}
